import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AddinquiryComponent } from "./addinquiry/addinquiry.component";
import { DetailinquiryEditproductComponent } from "./detailinquiry-editproduct/detailinquiry-editproduct.component";
import { DetailinquiryComponent } from "./detailinquiry/detailinquiry.component";
import { EditinquiryComponent } from "./editinquiry/editinquiry.component";
import { InquirydocumentComponent } from "./editinquiry/inquirydocument/inquirydocument.component";
import { InquirylistComponent } from "./inquirylist/inquirylist.component";

const routes: Routes = [
  {
    path: "inquirylist",
    component: InquirylistComponent,
  },
  {
    path: "addinquiry",
    component: AddinquiryComponent,
  },
  {
    path: "editinquiry/:id",
    component: EditinquiryComponent,
    data: {
      allowedRoles: ["maven", "inquiry"],
    },
    children: [
      {
        path: "inquirydocument",
        component: InquirydocumentComponent,
        data: {
          allowedRoles: ["maven", "inquiry", "inquirylist"],
        },
      },
    ],
  },
  {
    path: "detailinquiry/:id",
    component: DetailinquiryComponent,
  },
  {
    path: "detailinquiry-editproduct/:id",
    component: DetailinquiryEditproductComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InquiryRoutingModule {}
